(function () {
  function setHeight(details, open) {
    var content = details.querySelector('.rcg-content');
    if (!content) return;
    content.style.maxHeight = open ? content.scrollHeight + 'px' : '0px';
  }

  // Idempotent: safe to run every time this file is parsed (once per section
  // instance on the page), so an already-open item always gets a real height.
  document.querySelectorAll('[data-rcg-section] details.rcg-accordion[open]').forEach(function (details) {
    setHeight(details, true);
  });

  // Everything below only needs to run once globally, even if this section
  // is used several times on the same page (each instance would otherwise
  // include its own copy of this script tag).
  if (window.__ringCareAccordionInitialized) return;
  window.__ringCareAccordionInitialized = true;

  // 'toggle' and media 'load' events do not bubble, so they're caught here
  // during the capture phase on document instead of via normal delegation.
  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!(details instanceof HTMLElement) || !details.classList.contains('rcg-accordion')) return;

    var section = details.closest('[data-rcg-section]');
    if (!section) return;

    if (details.open) {
      section.querySelectorAll('details.rcg-accordion').forEach(function (other) {
        if (other !== details && other.open) other.open = false;
      });
    }

    setHeight(details, details.open);
  }, true);

  document.addEventListener('load', function (event) {
    var img = event.target;
    if (!(img instanceof HTMLImageElement)) return;
    var details = img.closest('details.rcg-accordion');
    if (details && details.open) setHeight(details, true);
  }, true);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('[data-rcg-section] details.rcg-accordion[open]').forEach(function (details) {
        setHeight(details, true);
      });
    }, 150);
  });
})();
